import React from 'react';
import { injectIntl, useIntl, WrappedComponentProps } from 'react-intl';
import {
    CHARGERS_OPTION_TYPE_ID,
    ME_CHARGERS_OPTION_TYPE_ID,
} from '../../common/constants';
interface Props {
    accesoryName: string;
    productNumber: string;
    quantity: number;
    onQuantityChanged: (
        partNumber: string,
        quantity: number,
        isCharger?: boolean
    ) => void;
    patientOrder: boolean;
    optionTypeId: number;
}

const AccessoryElementIntl: React.FC<Props> = ({
    accesoryName,
    productNumber,
    quantity,
    onQuantityChanged,
    patientOrder,
    optionTypeId,
}) => {
    const intl = useIntl();
    const addDelete = (add: boolean) => {
        if (
            optionTypeId === CHARGERS_OPTION_TYPE_ID ||
            optionTypeId === ME_CHARGERS_OPTION_TYPE_ID
        ) {
            add
                ? onQuantityChanged(productNumber, quantity + 1, true)
                : onQuantityChanged(productNumber, quantity - 1, true);
        } else {
            add
                ? onQuantityChanged(productNumber, quantity + 1)
                : onQuantityChanged(productNumber, quantity - 1);
        }
    };

    return (
        <div
            className="col-sm-12"
            style={{ marginBottom: '25px', height: '115px' }}
        >
            <div className="col-sm-12">
                <h3
                    className="accessory-element-intl__header"
                    style={{ fontSize: 'small' }}
                    id="accessory-name"
                >
                    {accesoryName}
                </h3>
            </div>
            <h4 className="col-sm-12" id="accessory-part-number">
                {productNumber}
            </h4>
            {quantity >= 1 && (
                <>
                    <div className="col-sm-5">
                        <div
                            className="btn-group container"
                            role="group"
                            style={{ marginLeft: '-20px' }}
                        >
                            {patientOrder ? (
                                <div
                                    style={{
                                        display: 'flex',
                                    }}
                                >
                                    <div
                                        style={{
                                            alignItems: 'center',
                                            padding: '1%',
                                        }}
                                    >
                                        <span
                                            id="accessory-selected"
                                            style={{
                                                fontSize: 'large',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {intl.formatMessage({
                                                id: 'Selected',
                                                defaultMessage: 'Selected',
                                            })}
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <button
                                        id="accessory-minus"
                                        type="button"
                                        className="btn btn-group-sm btn-default"
                                        onClick={() => addDelete(false)}
                                    >
                                        -
                                    </button>
                                    <input
                                        id="accessory-quantity"
                                        type="text"
                                        className="btn btn-group-sm btn-default"
                                        style={{ width: '55px' }}
                                        value={intl.formatNumber(quantity)}
                                        readOnly={true}
                                    />
                                    <button
                                        id="accessory-add"
                                        type="button"
                                        className="btn btn-group-sm btn-default"
                                        onClick={() => addDelete(true)}
                                    >
                                        +
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-2" />
                </>
            )}
            <div className="col-sm-5">
                {quantity <= 0 ? (
                    <button
                        id="accessory-select"
                        type="button"
                        onClick={() => addDelete(true)}
                        className="btn btn-primary btn-sm"
                    >
                        {intl.formatMessage({
                            id: 'Select',
                            defaultMessage: 'Select',
                        })}
                    </button>
                ) : (
                    <button
                        id="accessory-cancel"
                        type="button"
                        onClick={() => onQuantityChanged(productNumber, 0)}
                        className="btn btn-danger btn-sm"
                    >
                        {intl.formatMessage({
                            id: 'Cancel',
                            defaultMessage: 'Cancel',
                        })}
                    </button>
                )}
            </div>
        </div>
    );
};

export default AccessoryElementIntl;
